/* components/kitchen/menu/ListEditor.jsx — добавление нового раздела меню без блюд.
   Поле названия + «Добавить»; Enter добавляет, Esc сбрасывает.
   ХЕНДОФФ → frontend/src/components/kitchen/menu/ListEditor.jsx. */

import React from 'react';
import { Button } from '../../ui/Button.jsx';
import { TextInput } from '../../ui/Field.jsx';

  const { useState } = React;

  function ListEditor({ onAdd, placeholder = 'Название раздела', label = '+ Раздел' }) {
    const [open, setOpen] = useState(false);
    const [val, setVal] = useState('');
    const add = () => { const t = val.trim(); if (!t) return; onAdd && onAdd(t); setVal(''); setOpen(false); };
    const onKey = (e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } else if (e.key === 'Escape') { setVal(''); setOpen(false); } };

    if (!open) return <Button variant="secondary" size="sm" iconLeft="plus" onClick={() => setOpen(true)}>{label}</Button>;
    return (
      <div className="list-editor">
        <TextInput value={val} placeholder={placeholder} onChange={(e) => setVal(e.target.value)} onKeyDown={onKey} autoFocus />
        <Button variant="primary" size="sm" onClick={add} disabled={!val.trim()}>Добавить</Button>
        <Button variant="ghost" size="sm" onClick={() => { setVal(''); setOpen(false); }}>Отмена</Button>
      </div>
    );
  }

export { ListEditor };
